const mfa = {
    title: 'Multi-factor authentication',
    description: 'Add multi-factor authentication to elevate the security of your sign-in experience.',
    factors: 'Factors',
    multi_factors: 'Multi-factors',
    multi_factors_description: 'Users need to verify one of the enabled factors for 2-step verification.',
    totp: 'Authenticator app OTP',
    otp_description: 'Link Google Authenticator, etc., to verify one-time passwords.',
    webauthn: 'WebAuthn (Passkey)',
    webauthn_description: 'Verify via browser-supported method: biometrics, phone scanning, or security key, etc.',
    webauthn_native_tip: 'WebAuthn is not supported for Native applications.',
    webauthn_domain_tip: 'WebAuthn binds public keys to the specific domain. Modifying your service domain will block users from authenticating via existing passkeys.',
    email: 'Email Verification',
    email_description: 'Verify using Email verification code.',
    sms: 'SMS Verification',
    sms_description: 'Verify using SMS verification code.',
    wa: 'Whatsapp Verification',
    wa_description: 'Verify using Whatsapp verification code.',
    backup_code: 'Backup code',
    backup_code_description: 'Generate 10 one-time backup codes after users set up any MFA method.',
    backup_code_setup_hint: "When users can't verify the above MFA factors, use the backup option.",
    backup_code_error_hint: 'To use a backup code, you need at least one more MFA method for successful user authentication.',
    at_least_one_factor_error: 'At least one MFA factor must stay enabled.',
    policy: 'Policy',
    policy_description: 'Set the MFA policy for sign-in and sign-up flows.',
    two_step_sign_in_policy: '2-step verification policy at sign-in',
    user_controlled: 'Users can enable or disable MFA on their own',
    user_controlled_tip: 'Users can skip the MFA set-up the first time at sign-in or sign-up, or enable/disable it in account settings.',
    mandatory: 'Users are always required to use MFA at sign-in',
    mandatory_tip: 'Users must set up MFA the first time at sign-in or sign-up, and use it for all future sign-ins.',
    require_mfa: 'Require MFA',
    require_mfa_label: 'Enable this to make 2-step verification mandatory for accessing your applications. If disabled, users can decide whether to enable MFA for themselves.',
    set_up_prompt: 'MFA set-up prompt',
    no_prompt: 'Do not ask users to set up MFA',
    prompt_at_sign_in_and_sign_up: 'Ask users to set up MFA during registration (skippable, one-time prompt)',
    prompt_only_at_sign_in: 'Ask users to set up MFA on their next sign-in attempt after registration (skippable, one-time prompt)',
    trusted_device: 'Trusted device',
    trusted_device_description: 'Let users skip MFA on the same browser for a period after a successful 2-step verification.',
    trusted_device_field: 'Remember device',
    trusted_device_switch_label: 'Allow users to remember this device after MFA verification',
    trusted_device_ttl_days: 'Remember duration (days, default 30)',
    session: 'Login session',
    session_description: 'Set how long an authenticated session (SSO) stays valid before users must sign in again.',
    session_ttl_days: 'Login session duration (1–30 days, default 7)',
    session_ttl_days_error: 'Enter a value between 1 and 30 days.',
    idle_timeout_minutes: 'Admin console idle timeout (1–120 minutes, empty to disable)',
    idle_timeout_minutes_error: 'Enter a value between 1 and 120 minutes.',
    security_limits: 'Security limits',
    security_limits_description: 'Configure verification attempt limits and sign-in session timeout. Leave a field empty to use the default value.',
    otp_max_try_count: 'Max wrong attempts per verification code (default 3)',
    interaction_ttl_seconds: 'Sign-in session timeout (seconds, default 3600)',
    sentinel_max_attempts: 'Failed attempts within 1 hour before lockout (default 5)',
    sentinel_block_duration_minutes: 'Lockout duration (minutes, default 10)',
    reverse_otp: 'WhatsApp reverse OTP',
    reverse_otp_description: 'Configure inbound WhatsApp reverse-OTP verification. Available only when WhatsApp verification is enabled.',
    reverse_otp_field: 'Reverse OTP',
    reverse_otp_switch_label: 'Enable WhatsApp reverse OTP',
    reverse_otp_provider: 'Provider',
    reverse_otp_business_number: 'Business number',
    reverse_otp_message_template: 'Message template',
    reverse_otp_meta_phone_number_id: 'Meta phone number ID',
    reverse_otp_meta_app_secret: 'Meta app secret',
    reverse_otp_meta_verify_token: 'Meta verify token',
    reverse_otp_openwa_base_url: 'OpenWA base URL',
    reverse_otp_openwa_api_key: 'OpenWA API key',
    reverse_otp_openwa_session_id: 'OpenWA session ID',
    reverse_otp_openwa_webhook_secret: 'OpenWA webhook secret (optional)',
    reverse_otp_openwa_signature_header: 'OpenWA signature header (optional)',
};
export default Object.freeze(mfa);
